module.exports = __webpack_public_path__ + "1c79e9ba2743f7490a66ec170d948492.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/wall_items/dragon-poster.png
// module id = 3243
// module chunks = 0